import React from 'react';
import './Sections.scss';

function Section4() {
  return (
    <section className="sections sections-section4">
      <h2 className="sections-title">No going back (to the office)</h2>
      <p className="sections-copy">
        With millions of people now working from home due to the pandemic, or working a flexible
        schedule that requires only a few days in the office, what buyers look for in a home
        continues to be shaken up. It’s also changing where they want to live. Many employees have
        happily traded the hours per week they used to spend stuck in traffic or packed into public
        transit for the blissfully short commute to a home office desk or kitchen table.
      </p>
    </section>
  );
}

export default Section4;
